import React from "react";
import {
  AppleIcon,
  AvocadoIcon,
  BeconIcon,
  BreadIcon,
  FireIcon,
} from "../../../../images/icons/icons";

const PlanSummaryCard = ({ plan }) => {
  if (!plan) return null;
  return (
    <section className="tme-nutrition-analysis__plan-card">
      <div className="tme-nutrition-analysis__plan-header">
        <span className="tme-nutrition-analysis__plan-icon" aria-hidden>
          <AppleIcon color="#000" />
        </span>
        <h3 className="tme-nutrition-analysis__plan-title">{plan.title}</h3>
      </div>

      <div className="tme-nutrition-analysis__plan-meta">
        <div className="tme-nutrition-analysis__meta-item">
          <div className="tme-nutrition-analysis__meta-label">Assigned By</div>
          <div className="tme-nutrition-analysis__meta-value">
            {plan.assignedBy}
          </div>
        </div>
        <div className="tme-nutrition-analysis__meta-item">
          <div className="tme-nutrition-analysis__meta-label">Duration</div>
          <div className="tme-nutrition-analysis__meta-value">
            {plan.duration.start} - {plan.duration.end}
          </div>
        </div>
      </div>

      <div className="tme-nutrition-analysis__targets">
        <div className="tme-nutrition-analysis__target-box">
          <div className="tme-nutrition-analysis__target-label">
            Target Calories
          </div>
          <div className="tme-nutrition-analysis__target-value">
            {plan.targets.calories}
            <span className="tme-nutrition-analysis__target-icon">
              <FireIcon color="#ED3F27" />
            </span>
          </div>
        </div>
        <div className="tme-nutrition-analysis__target-box">
          <div className="tme-nutrition-analysis__target-label">
            Protein (g)
          </div>
          <div className="tme-nutrition-analysis__target-value">
            {plan.targets.protein}
            <span className="tme-nutrition-analysis__target-icon">
              <BeconIcon color="#B45253" />
            </span>
          </div>
        </div>
        <div className="tme-nutrition-analysis__target-box">
          <div className="tme-nutrition-analysis__target-label">Carbs (g)</div>
          <div className="tme-nutrition-analysis__target-value">
            {plan.targets.carbs}
            <span className="tme-nutrition-analysis__target-icon">
              <BreadIcon color="#EBCB90" />
            </span>
          </div>
        </div>
        <div className="tme-nutrition-analysis__target-box">
          <div className="tme-nutrition-analysis__target-label">Fats (g)</div>
          <div className="tme-nutrition-analysis__target-value">
            {plan.targets.fats}
            <span className="tme-nutrition-analysis__target-icon">
              <AvocadoIcon color="#8FA31E" />
            </span>
          </div>
        </div>
      </div>

      <div className="tme-nutrition-analysis__lists">
        <div className="tme-nutrition-analysis__list">
          <div className="tme-nutrition-analysis__list-title">Goals</div>
          <ul>
            {plan.goals.length > 0 ? (
              plan.goals.map((g, i) => (
                <li key={i} className="tme-nutrition-analysis__goal-item">
                  <span className="tme-nutrition-analysis__goal-dot" />
                  {g}
                </li>
              ))
            ) : (
              <li className="tme-nutrition-analysis__goal-item">
                <span className="tme-nutrition-analysis__goal-dot" />
                None
              </li>
            )}
          </ul>
        </div>
        <div className="tme-nutrition-analysis__list">
          <div className="tme-nutrition-analysis__list-title">
            Dietary Restrictions
          </div>
          <ul>
            {plan.restrictions.length > 0 ? (
              plan.restrictions.map((r, i) => (
                <li
                  key={i}
                  className="tme-nutrition-analysis__restriction-item"
                >
                  <span className="tme-nutrition-analysis__restriction-dot" />
                  {r}
                </li>
              ))
            ) : (
              <li className="tme-nutrition-analysis__restriction-item">
                <span className="tme-nutrition-analysis__restriction-dot" />
                None
              </li>
            )}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default PlanSummaryCard;
